var Gallery = class {
	constructor(wrapper) {
        this._declare(wrapper);
        this._addScroll();
        if(this.isTouch()) return false;
        this._addEvents();
        this._checkNav();
	}

    isTouch(){
        return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
    }

    _declare(wrapper) {
        this.wrapper = wrapper;
        this.frame = wrapper.querySelector('[data-Gallery-frame]');
        this.strip = wrapper.querySelector('[data-Gallery-strip]');
        this.left = this._createBtn('left');
        this.right = this._createBtn('right');
    }

    _addScroll(){
        var hScroll = window.innerWidth - document.body.clientWidth,
            bottom = hScroll ? ('margin-bottom:-' + hScroll + 'px') : '' ;

        this.frame.style.cssText = 'overflow-y:hidden;overflow-x:scroll;' + bottom;
    }

    _addEvents(){
        var self = this;

        window.addEventListener('resize', function(){self._checkNav.call(self)});
        window.addEventListener('orientationchange', function(){self._checkNav.call(self)});
        this.frame.addEventListener('scroll', function(){self._checkNav.call(self)});
        this.frame.addEventListener('wheel', function(e){self._onWheel.call(self, e)});
    }

    _onWheel(e){
        var delta = e.deltaY > 0 ? 40 : -40;
        this.frame.scrollLeft = this.frame.scrollLeft + delta;

        if ((delta > 0) && (this.right.el.className.indexOf('js-active') != -1)) e.preventDefault();
        else if ((delta < 0) && this.left.el.className.indexOf('js-active') != -1) e.preventDefault();
    }

    _checkNav(){
        var w = this.frame.getBoundingClientRect().width,
            scrollWidth = Math.floor(this.strip.getBoundingClientRect().width),
            isScroll = scrollWidth - w,
            scrollLeft;

        //
        if(isScroll){
            scrollLeft = this.frame.scrollLeft;

            if(w >=  (scrollWidth + scrollLeft)){
                this._hideNav(['left','right']);
            }
            else if(!scrollLeft){
                this._showNav(['right']);
                this._hideNav(['left']);
            }
            else if((scrollLeft + w) >=  scrollWidth){
                this._showNav(['left']);
                this._hideNav(['right']);
            }
            else {
                this._showNav(['left','right']);
            }
        }
        else this._hideNav(['right', 'left']);
    }

    _hideNav(arr){
        for(var i=0,j=arr.length; i<j; i++){

            var btn = this[arr[i]];
            if(btn && btn.el.className.indexOf(' js-active') != -1)  btn.el.className = btn.el.className.replace(' js-active', '');
        }
    }

    _showNav(arr){
        for(var i=0,j=arr.length; i<j; i++){
            var btn = this[arr[i]];
            
            if(btn.el.className.indexOf(' js-active') === -1)  btn.el.className =  btn.el.className + ' js-active';
        }
    }

    _createBtn(name){
        var parent = this,
            Btn = class{
                constructor(){
                    this._declare();
                    this._createEl();
                    this._addEvents();
                }

                _declare(){
                    this.el;
                    this.sign = name === 'left' ? -7 : 7;
                    this.isDown = false;
                }

                _createEl(){
                    this.el = document.createElement('BUTTON');
                    this.el.className = 'gallery_btn gallery_btn-' + name;
                    parent.wrapper.appendChild(this.el);
                }

                _addEvents(){
                    var self = this;

                    this.el.onmousedown = function(){
                        self.isDown = true;
                        self._move.call(self);
                    };

                    document.body.addEventListener('mouseup', function(){
                        self.isDown = false;
                    });

                    document.body.addEventListener('mouseleave', function(){
                        self.isDown = false;
                    });

                }

                _move(){
                    if(!this.isDown) return false;

                    var self = this,
                        frame = parent.frame;

                    frame.scrollLeft = frame.scrollLeft + this.sign;
                    requestAnimationFrame(function(){self._move.call(self)});
                }
            };

        //
        parent[name] =  new Btn();
        return parent[name];
    }
};

export {Gallery};





































